import type { Nps } from "../lib/types";

interface Props {
  value: Nps | null;
  onChange: (v: Nps) => void;
}

const OPTIONS: Array<{ value: Nps; label: string }> = [
  { value: "promoter", label: "Very likely" },
  { value: "passive", label: "Maybe" },
  { value: "detractor", label: "Not at all" },
];

export function NpsChoice({ value, onChange }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label="Recommendation likelihood"
      className="grid grid-cols-3 gap-2"
    >
      {OPTIONS.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            // biome-ignore lint/a11y/useSemanticElements: custom-styled radiogroup; <input type="radio"> doesn't support the visual treatment
            role="radio"
            aria-checked={active}
            onClick={() => onChange(o.value)}
            className={`select-none rounded-xl border px-2 py-4 text-sm font-semibold uppercase tracking-wider transition-colors active:scale-95 ${
              active
                ? "border-amber bg-amber text-charcoal"
                : "border-cream/15 bg-charcoal-2 text-cream hover:border-amber/40"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
